<script>
  import { settingsStore } from '../stores/settingsStore.js';
  import { user } from '../stores/authStore.js';

  const { billSettings, error, success, initialized } = settingsStore;

  // Owner and admin manage this org setting. Other roles see it read-only.
  // A user with no organisation still controls their own switch.
  $: canEditApproval = !$user?.orgId || $user?.orgRole === 'owner' || $user?.orgRole === 'admin';
  $: enabled = $initialized
    ? $billSettings.requireDirectBillApproval === true
    : $user?.billSettings?.requireDirectBillApproval === true;

  function setFlag(next) {
    user.update((current) => {
      if (!current) return current;
      return {
        ...current,
        billSettings: {
          ...(current.billSettings || {}),
          requireDirectBillApproval: next
        }
      };
    });
    billSettings.update((current) => ({ ...current, requireDirectBillApproval: next }));
  }

  async function toggleApproval(event) {
    const next = event.currentTarget.checked;
    const previous = !next;
    setFlag(next);
    error.set(null);
    try {
      const res = await fetch('/api/users/direct-bill-approval', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ requireDirectBillApproval: next })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success) {
        throw new Error(data.error || 'Failed to update approval setting');
      }
      success.set('✅ Approvals setting updated!');
      setTimeout(() => success.set(null), 2000);
    } catch (err) {
      setFlag(previous);
      error.set(err.message || 'Failed to update approval setting');
    }
  }
</script>

<div class="flex items-center justify-between p-4 bg-white rounded-md border border-gray-200">
  <div class="pr-4">
    <p class="text-sm font-medium text-gray-700">Require Approval Step during import</p>
    <p class="text-xs text-gray-500 mt-1">
      When enabled, reviewed bills must be submitted for approval before they can be synced to Xero and JobTread.
    </p>
  </div>
  <div class="flex items-center gap-3 flex-shrink-0">
    <span class="text-sm font-bold {enabled ? 'text-green-600' : 'text-red-600'}">
      {enabled ? 'ON' : 'OFF'}
    </span>
    <label class="relative inline-flex items-center {canEditApproval ? 'cursor-pointer' : 'cursor-not-allowed'}">
      <input
        type="checkbox"
        checked={enabled}
        on:change={toggleApproval}
        disabled={!canEditApproval}
        class="sr-only peer"
      />
      <div class="w-14 h-7 bg-red-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-green-500"></div>
    </label>
  </div>
</div>
